// extracted by mini-css-extract-plugin
module.exports = {"container":"e__2","textBadge":"e_02","buttonBlock":"e_12"};